<template>
  <div class="user" v-loading="loading">
    <el-form size="small" ref="form" :model="form" label-width="200px">
      <div class="common-form">参数设置</div>
      <el-form-item label="用户中心展示图片">
        <el-button @click="openUpload(1)">选择图片</el-button>
        <el-button type="text" @click="delImage(1)">清除</el-button>
        <img class="mt10" v-img-url="form.user_img" width="100">
        <div>建议尺寸：750x360；</div>
      </el-form-item>
      <el-form-item label="是否开启生日有礼：">
        <el-radio-group v-model="form.open_birth_gift">
          <el-radio :label="1">开启</el-radio>
          <el-radio :label="0">关闭</el-radio>
        </el-radio-group>
        <div class="red">开启后生日当月可领取以下奖励</div>
      </el-form-item>
      <el-form-item label="赠送商品领取时效">
        <el-input type="number" min="0" v-model="form.limit_day" class="max-w460">
          <template slot="append">天</template>
        </el-input>
        <div>过期不领取直接失效</div>
      </el-form-item>
      <el-form-item label="参与等级">
       <el-select v-model="grade_id" placeholder="请选择" @change="changeGrade">
         <el-option v-for="(item,index) in gradeList" :key="index" :label="item.name"  :value="item.grade_id">
         </el-option>
        
       </el-select>
       <el-button type="primary" icon="el-icon-plus" size="small" @click="addTab">添加</el-button>
     </el-form-item>
      <el-tabs v-model="activeIndex" closable @tab-remove="removeTab">
        <el-tab-pane :label="item.grade.name" :name="index" v-for="(item, index) in gradeSetting" :key="index">
            <div v-if="activeIndex==index">
              <template>
                <el-form-item label="弹窗图片" prop="image_id">
                  <el-row>
                    <el-button type="primary" @click.stop="openUpload(2)">选择图片</el-button>
                    <el-button type="text" @click="delImage(2)">清除</el-button>
                    <div v-if="item.setting.image_cover!=''" class="img">
                      <img :src="item.setting.image_cover" width="100" height="100" />
                    </div>
                    <div>建议尺寸：600x250；</div>
                  </el-row>
                </el-form-item>
                <el-form-item label="文案描述" prop="content">
                  <el-input type="textarea" :rows="2" max="100" placeholder="请输入说明" v-model="item.setting.content" class="max-w460"></el-input>
                </el-form-item>
                <el-form-item label="送优惠券管理">
                  <el-button type="primary" @click="addCoupon()">添加</el-button>
                  <el-table :data="item.setting.coupon" style="width: 600px">
                    <el-table-column prop="coupon_id" label="优惠券id">
                    </el-table-column>
                    <el-table-column prop="name" label="优惠券">
                    </el-table-column>
                    <el-table-column prop="coupon_num" label="赠送数量" :rules="[{required: true,message: ' '}]">
                      <template slot-scope="scope">
                        <el-input type="number" v-model="scope.row.coupon_num" placeholder="" min="1" max='10' @blur='max10'></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column prop="address" label="操作">
                      <template slot-scope="scope">
                        <el-button type="text" size="small" @click='delcoupon(scope.row)'> 删除 </el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-form-item>
                <el-form-item label="商品管理" prop="product_list">
                  <el-button icon="el-icon-plus" @click="changeProduct(prodcutData)">选择商品</el-button>
                  <div class="pt16">
                    <el-table size="mini" :data="item.setting.product" border style="width: 600px">
                      <el-table-column label="商品ID"  prop="product_id" ></el-table-column>
                      <el-table-column label="商品名称">
                        <template slot-scope="scope">
                          <p class="text-ellipsis-2">{{ scope.row.product_name }}</p>
                        </template>
                      </el-table-column>
                      <el-table-column prop="product_num" label="赠送数量" :rules="[{required: true,message: ' '}]">
                      <template slot-scope="scope">
                        <el-input type="number" v-model="scope.row.product_num" placeholder="" min="1" max='10' @blur='max10'></el-input>
                      </template>
                    </el-table-column>
                      <el-table-column fixed="right" label="操作" width="100">
                        <template slot-scope="scope">
                          <el-button @click="delProduct(scope.$index)" type="text" size="small">删除</el-button>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                </el-form-item>
                <el-form-item label="赠送">
                  <el-input type="number" v-model="item.setting.points" class="max-w460">
                    <template slot="append">积分</template>
                  </el-input>
                </el-form-item>
            </template>
            </div>
            
        </el-tab-pane>
      </el-tabs>
 
    
      <!-- <template>
          <el-form-item label="弹窗图片" prop="image_id">
            <el-row>
              <el-button type="primary" @click="openUpload(2)">选择图片</el-button>
              <el-button type="text" @click="delImage(2)">清除</el-button>
              <div v-if="form.image_cover!=''" class="img">
                <img :src="form.image_cover" width="100" height="100" />
              </div>
              <div>建议尺寸：600x250；</div>
            </el-row>
          </el-form-item>
          <el-form-item label="文案描述" prop="content">
            <el-input type="textarea" :rows="2" max="100" placeholder="请输入说明" v-model="form.content" class="max-w460"></el-input>
          </el-form-item>
          <el-form-item label="送优惠券管理">
            <el-button type="primary" @click="addCoupon()">添加</el-button>
            <el-table :data="form.coupon" style="width: 600px">
              <el-table-column prop="coupon_id" label="优惠券id">
              </el-table-column>
              <el-table-column prop="name" label="优惠券">
              </el-table-column>
              <el-table-column prop="coupon_num" label="赠送数量" :rules="[{required: true,message: ' '}]">
                <template slot-scope="scope">
                  <el-input type="number" v-model="scope.row.coupon_num" placeholder="" min="1" max='10' @blur='max10'></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="address" label="操作">
                <template slot-scope="scope">
                  <el-button type="text" size="small" @click='delcoupon(scope.row)'> 删除 </el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
          <el-form-item label="商品管理" prop="product_list">
            <el-button icon="el-icon-plus" @click="changeProduct(prodcutData)">选择商品</el-button>
            <div class="pt16">
              <el-table size="mini" :data="form.product" border style="width: 600px">
                <el-table-column label="商品ID"  prop="product_id" ></el-table-column>
                <el-table-column label="商品名称">
                  <template slot-scope="scope">
                    <p class="text-ellipsis-2">{{ scope.row.product_name }}</p>
                  </template>
                </el-table-column>
                <el-table-column prop="product_num" label="赠送数量" :rules="[{required: true,message: ' '}]">
                <template slot-scope="scope">
                  <el-input type="number" v-model="scope.row.product_num" placeholder="" min="1" max='10' @blur='max10'></el-input>
                </template>
              </el-table-column>
                <el-table-column fixed="right" label="操作" width="100">
                  <template slot-scope="scope">
                    <el-button @click="delProduct(scope.$index)" type="text" size="small">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-form-item>
          <el-form-item label="赠送">
            <el-input type="number" v-model="form.points" class="max-w460">
              <template slot="append">积分</template>
            </el-input>
          </el-form-item>
      </template> -->
      
     
    </el-form>

    <!--提交-->
    <div class="common-button-wrapper">
      <el-button size="small" type="primary" @click="onSubmit" :disabled="loading">保存</el-button>
    </div>
    <!--上传图片组件-->
   <Upload v-if="isupload" :isupload="isupload" :type="type" @returnImgs="returnImgsFunc">上传图片</Upload>
    <!--选择优惠券-->
   <GetCoupon v-if="open_add" :open_add="open_add" @closeDialog="closeProductDialogFunc($event)">选择优惠券弹出层</GetCoupon>
   <!--选择商品-->
   <Product :isproduct="isproduct" :excludeIds="exclude_ids" :islist="false" @closeDialog="closeProductFunc"></Product>
  </div>

</template>

<script>
  import GetCoupon from '@/components/coupon/GetCoupon';
  import Product from '@/components/product/Product.vue';
  import Upload from '@/components/file/Upload';
  import UserApi from '@/api/user.js'
export default {
  components: {
    /*选择商品组件*/
     GetCoupon,
      Product,
      Upload
  },
  data() {
    return {
      /*是否正在加载*/
      loading: true,
      imgType:0,
      grade_id:0,
      /*表单对象*/
      form: {
        /*是否开启*/
        open_birth_gift: 0,
        limit_day: 7,
        //赠送商品
        product: [],
        /*赠送积分*/
        points: 0,
        image_cover: '',
        user_img: '',
        content: '',
        /*赠送优惠券*/
        coupon: []
      },
      setting:{
        product:[],
        points:0,
        image_cover:'',
        coupon:[],
        content:'',
      },
      activeIndex:0,
      gradeSetting: [],
      gradeList: [],
      couponData: [],
      prodcutData:[],
      /*是否打开图片选择*/
      isupload:false,
      open_add: false,
        /*是否打开选择商品*/
      isproduct: false,
      exclude_ids: [],
    };
  },
  created() {
    /*获取列表*/
    this.getData();
  },
  methods: {
    changeGrade(e){
      console.log('数据调整')
      console.log(e);

    },
    /*获取数据*/
    getData(){
      let self = this;
      self.loading = true;
      UserApi.getSettingData({}, true)
        .then(res => {
          self.form = res.data.setting;
          self.gradeList = res.data.gradeList;
          self.gradeSetting = res.data.gradeSetting;
          self.loading = false;
        })
        .catch(error => {});
    },

    /*提交表单*/
    onSubmit() {
      let self = this;
      self.loading = true;
      self.form.gradeSetting = JSON.stringify(self.gradeSetting);
      UserApi.saveSettingData(self.form, true)
        .then(data => {
          self.loading = false;
          self.$message({
            message: '恭喜你，保存成功',
            type: 'success'
          });
          this.getData();
        })
        .catch(error => {
          self.loading = false;
        });
    },

    /*打开添加*/
    changeProduct(list,index) {
      let arr = [];
      list.forEach(item => {
        arr.push(item.product_id);
      });
      this.excludeIds = arr;
      this.isproduct = true;
    },
/*添加商品*/
      addProduct() {

         this.isproduct = true;

      },
      /*关闭商品*/
      closeProductFunc(e) {
          let self = this;
          self.isproduct = e.openDialog;
          if (e.type == 'success') {
            var temp = {
                product_id:e.params.product_id,
                product_name:e.params.product_name,
                product_num:1,
              }
              self.gradeSetting[self.activeIndex].setting.product.push(temp);
              this.$forceUpdate();
          }
      },
    /*添加优惠券*/
      addCoupon() {
        this.open_add = true;
      },
      /*关闭优惠券*/
      closeProductDialogFunc(e) {
        let self = this;
        self.open_add = e.openDialog;
        if (e.type == 'success') {
          if(self.gradeSetting[self.activeIndex].setting.coupon.length<1){
              var temp = {
                coupon_id:e.params.coupon_id,
                name:e.params.name,
                coupon_type:e.params.coupon_type,
                coupon_num:1,
              }
               e.params.coupon_num=1;
               self.gradeSetting[self.activeIndex].setting.coupon.push(temp);
          }else{
            let flag=true;
           self.gradeSetting[self.activeIndex].setting.coupon.forEach((item,index)=>{
             if(item.coupon_id==e.params.coupon_id){
               flag=false
             }
           })
           if(flag){
              var temp = {
                coupon_id:e.params.coupon_id,
                name:e.params.name,
                coupon_type:e.params.coupon_type,
                coupon_num:1,
              }
             self.gradeSetting[self.activeIndex].setting.coupon.push(temp);
           }else{
              self.$message.error('请勿重复添加');
           }
          }
        }
      },
      delProduct(item) {
        let self = this;
        let n = self.gradeSetting[self.activeIndex].setting.product.indexOf(item);
        self.gradeSetting[self.activeIndex].setting.product.splice(n, 1);
      },
      delcoupon(item){
          let self=this;
          let n=self.gradeSetting[self.activeIndex].setting.coupon.indexOf(item);
          self.gradeSetting[self.activeIndex].setting.coupon.splice(n,1);
      },
      /*上传*/
      openUpload(e) {
        this.imgType = e;
        this.isupload = true;
      },
      /*获取图片*/
      returnImgsFunc(e) {
        let self = this;
        console.log(this.gradeSetting[self.activeIndex])
        console.log(this.imgType)
        if (e != null && e.length > 0) {
          if(this.imgType==2){
              this.gradeSetting[self.activeIndex].setting.image_cover = e[0].file_path;
          }
          if(this.imgType==1){
              this.form.user_img = e[0].file_path;
          }
          
        }
        console.log(this.gradeSetting)
        this.isupload = false;
        this.$forceUpdate();
      },
      delImage(imgType){
        let self = this;
        if(imgType==2){
            self.gradeSetting[self.activeIndex].setting.image_cover='';
        }
        if(imgType==1){
            self.form.user_img='';
        }
      },
      
      addTab() {
        if (!this.grade_id){
          this.$message({
            message: '请选择要添加的等级',
            type: 'warning'
          });
          return;
        }
        for (let index = 0; index < this.gradeSetting.length; index++) {
          if(this.gradeSetting[index].grade_id==this.grade_id){
            this.$message({
              message: '改等级已存在配置，请不要重复添加',
              type: 'warning'
            });
            return;
          }
          
        }
        // this.gradeSetting.forEach(item=>{
        //   if(item.grade_id==this.grade_id){
        //     this.$message({
        //       message: '改等级已存在配置，请不要重复添加',
        //       type: 'warning'
        //     });
        //     return;
        //   }
        // })
        this.gradeList.forEach(item=>{
          if(item.grade_id==this.grade_id){
            let data = {
                          grade_id:item.grade_id,
                          grade:item,
                          setting:{
                            product:[],
                            points:0,
                            image_cover:'',
                            coupon:[],
                            content:'',
                          }
                      }
              this.gradeSetting.push(data);
              console.log(this.gradeSetting)
          }
        })
        this.$forceUpdate();
      },

      /*删除支付方式*/
      removeTab(targetIndex) {
        console.log(targetIndex);
        this.$confirm('确定是否删除该配置?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
          let list = [];
          this.gradeSetting.forEach((item,index)=>{
            if(index!=targetIndex){
              list.push(item);
            }
          })
          console.log(list)
          this.gradeSetting = list;
          this.activeIndex = 0;
          this.$forceUpdate();
          
        }).catch(() => {});
      },

    }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/user/setting/index.vue